// extracted by mini-css-extract-plugin
export default {"price":"Y4-z","onSale":"Z4-z","msrpLabelPrice":"_4-z","msrpLabel":"a5-z","originalPrice":"b5-z","percentOff":"c5-z"};